import Api from "../../../../util/Api";

export default function getInitState() {
    return {
        headerFields: [
            {
                name: "id",
                label: "Foglalás ID",
                formVisible: false
            },
            {
                name: "operationId",
                label: "Műtés ID",
                formVisible: false
            },
            {
                name: "appointment",
                label: "Dátum",
                formRequired: true,
                formType: "dateTime",
                formSize: 3,
                formVisible: true
            },
            {
                name: "operationDuration",
                label: "Időtartam (perc)",
                formRequired: true,
                formType: "number",
                formSize: 2,
                formVisible: true
            },
            {
                name: "operationType",
                label: "Műtét típusa",
                formVisible: true,
                formSize: 4,
                formRequired: true,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllOperationType,
                    formatText: function (val) {
                        return val.bnoId + " - " + val.operation;
                    },
                    formatOption: function (val) {
                        return val.bnoId + " - " + val.operation;
                    },
                    minimumInputLength: 3,
                    searchOnServer: true,
                    filteredAttr: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },

            {
                name: "operationDoctor",
                label: "Operatőr",
                formType: 'select',
                formRequired: true,
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getAllDoctor,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    filteredAttr: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 3
            },
            {
                name: "operationScrub",
                label: "Műtős",
                formRequired: true,
                formVisible: true,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllOperationScrubs,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    filteredAttr: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 3
            },
            {
                name: "operationAnesthesiaDoctor",
                label: "Anesztéziát végzi",
                formRequired: true,
                formVisible: true,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllAnesthesist,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    filteredAttr: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 3
            },
            {
                name: "operationAnesthesiaId",
                label: "Anesztézia",
                formRequired: true,
                formVisible: true,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllAnesthesiaType,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 3
            },
            {
                name: "requiredOperationInvestigation",
                label: "Preop. szükséges vizsgálatok",
                formRequired: true,
                formType: "text",
                formSize: 3,
                formVisible: true
            },
            {
                name: "anesthInvestigation",
                label: "Anest. vizsgálat történt",
                formRequired: true,
                formType: "text",
                formSize: 3,
                formVisible: true
            },
            {
                name: "patientArrivalDate",
                label: "Beteg érkezése",
                formRequired: true,
                formType: "date",
                formSize: 3,
                formVisible: true
            },
            {
                name: "patientCareDuration",
                label: "Befekvés várható időtartama (éj)",
                formRequired: true,
                formType: "number",
                formSize: 3,
                formVisible: true
            },
            {
                name: "familyToFId",
                label: "Hozzátartozó befekszik",
                formRequired: true,
                formVisible: true,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllFamilyToFId,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 3
            },
            {
                name: "statusId",
                label: "Státusz",
                formVisible: true,
                formRequired: true,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getAppointmentStatus,
                    formatText: function (val) {
                        return '<div class="status-color status-' + val.tag + '"></div>' + val.text;
                    },
                    formatOption: function (val) {
                        return '<div class="status-color status-' + val.tag + '"></div>' + val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 3,
                event_name: "customChange",
                event_payload: "statusChange"
            },
            {
                name: "operationRoomId",
                label: "Műtő szoba",
                formRequired: true,
                formVisible: true,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllOperationRoom,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 3
            },
            {
                name: "operationBedId",
                label: "Ágy",
                formVisible: true,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllBedsForOperation,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 3
            },
            {
                name: "signCode",
                label: "Szignó kód",
                formRequired: true,
                formType: "text",
                formSize: 3,
                formVisible: true
            },
            {
                name: "note",
                label: "Megjegyzés",
                formRequired: false,
                formType: "textarea",
                formSize: 12,
                formVisible: true
            },
        ],
    }
}
